import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/BlindsCode/blindscommerce/app/inspiration/InspirationClient.tsx");
